import React from 'react';
import PropTypes from 'prop-types';
import Text from '@/v1/components/atoms/Text';

import './DisclaimerText.scss';

const propTypes = {
    data: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

const defaultProps = {
    data: null,
};

const disclaimerOverlayMarkup = (disclaimer) => {
    const body = disclaimer && disclaimer.body;

    return { __html: body };
};

const DisclaimerText = ({ data }) => {
    const disclaimer = data && data;

    return (
        <>
            <div className="DisclaimerOverlay__gradient-top" />
            <div className="DisclaimerOverlay__content">
                <Text className="DisclaimerOverlay__content__heading" component="h2">
                    {disclaimer && disclaimer.title}
                </Text>
                <div className="DisclaimerOverlay__content__copy transform-normal" dangerouslySetInnerHTML={disclaimerOverlayMarkup(disclaimer)} />
            </div>
            <div className="DisclaimerOverlay__gradient-bottom" />
        </>
    );
};

DisclaimerText.propTypes = propTypes;
DisclaimerText.defaultProps = defaultProps;

export default DisclaimerText;
